const regionNames = typeof Intl.DisplayNames === "function" ? new Intl.DisplayNames(["en"], { type: "region" }) : null;

const EDGE_NAMES: Record<string, string> = { A1: "Anonymous network", A2: "Satellite" };

/** "US" → "United States". Anything that is not a two-letter code comes back as typed. */
export function countryName(code: string | undefined): string {
  const c = (code ?? "").trim();
  if (!/^[A-Za-z]{2}$/.test(c)) return c;
  const upper = c.toUpperCase();
  if (EDGE_NAMES[upper]) return EDGE_NAMES[upper];
  try {
    return regionNames?.of(upper) ?? upper;
  } catch {
    return upper;
  }
}

/** City, region, and country, skipping whatever was not captured. */
export function formatLocation(place: { city?: string; region?: string; countryCode?: string }): string {
  return [place.city, place.region, countryName(place.countryCode)].filter(Boolean).join(", ");
}

/** City and state, skipping whichever was not captured. */
export function formatCityRegion(place: { city?: string; region?: string }): string {
  return [place.city?.trim(), place.region?.trim()].filter(Boolean).join(", ");
}
